<template>
  <div>
    <notifications></notifications>
    <router-view/>
  </div>
</template>

<script>
import router from "@/router";
import Notifications from "@/components/modules/Notifications";
export default {
  name: 'App',
  components: {Notifications},
  created() {
    this.$store.dispatch('tryAutoSignIn')
  }
}
</script>

<style>

</style>
